// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-ousl9 {
  background-color: #ff7f50;
}
.debug2-KjGU1 {
  background-color: #6495ed;
}
.emdbbuttom-JCg0H {
  position: relative;
  display: inline-block;
}
.emdbbuttom-JCg0H .buttom-qB8rq {
  width: auto;
  padding: 10px 20px;
  font-size: 1.125em;
  line-height: 25px;
  font-family: "AvenirBlack";
  background-color: #33CCFF;
  border-radius: 20px;
  text-align: center;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.2s linear;
}
.emdbbuttom-JCg0H .buttomdisable-CA8AY {
  width: auto;
  padding: 10px 20px;
  font-size: 1.125em;
  line-height: 25px;
  font-family: "AvenirBlack";
  background-color: #33CCFF;
  border-radius: 20px;
  text-align: center;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.2s linear;
  opacity: 0.6;
  cursor: not-allowed;
}
.emdbbuttom-JCg0H .buttom-qB8rq:hover {
  background-color: #29A3CC;
}
.emdbbuttom-JCg0H .buttomselected-j3Qiv {
  width: auto;
  padding: 10px 20px;
  font-size: 1.125em;
  line-height: 25px;
  font-family: "AvenirBlack";
  background-color: #33CCFF;
  border-radius: 20px;
  text-align: center;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.2s linear;
  background-color: #FF6698;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmdbButtom/emdbButtom.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAc,kBAAA;EAAoB,qBAAA;AAmClC;AAnCA;EAEa,WAAA;EAAa,kBAAA;ECoCxB,kBAAA;EDpC2D,iBAAA;EAAkB,0BAAA;EAA2B,yBAAA;EAA8B,mBAAA;EAAqB,kBAAA;EAAqB,cAAA;EAAe,eAAA;EAAgB,wCAAA;AA8CjN;AAhDA;EAEa,WAAA;EAAa,kBAAA;ECoCxB,kBAAA;EDpC2D,iBAAA;EAAkB,0BAAA;EAA2B,yBAAA;EAA8B,mBAAA;EAAqB,kBAAA;EAAqB,cAAA;EAAe,eAAA;EAAgB,wCAAA;EACpL,YAAA;EAAe,mBAAA;AA4D5C;AA/DA;EAIkB,yBAAA;AA8DlB;AAlEA;EAEa,WAAA;EAAa,kBAAA;ECoCxB,kBAAA;EDpC2D,iBAAA;EAAkB,0BAAA;EAA2B,yBAAA;EAA8B,mBAAA;EAAqB,kBAAA;EAAqB,cAAA;EAAe,eAAA;EAAgB,wCAAA;EAGnL,yBAAA;AA2E9B","sourcesContent":["@import \"../../assets/css/theme\";\n\n.emdbbuttom { position: relative; display: inline-block;\n    //.buttomdisable{position:absolute; width: auto; height: 45px; padding:10px; top:0; left:0; background-color:@colorgris4; border-radius: 20px; opacity:50%;}\n    .buttom {width: auto; padding:10px 20px; .font-base(18); line-height:25px; font-family:\"AvenirBlack\"; background-color:@colorazul1; border-radius: 20px; text-align: center;  color:#FFFFFF; cursor:pointer; transition:background-color 0.2s linear; }\n    .buttomdisable {.buttom; opacity: 0.6;  cursor:not-allowed;}\n    .buttom:hover{background-color:#29A3CC;}\n    .buttomselected{.buttom;  background-color:@colorrosa1;}\n}\n\n\n\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-ousl9`,
	"debug2": `debug2-KjGU1`,
	"emdbbuttom": `emdbbuttom-JCg0H`,
	"buttom": `buttom-qB8rq`,
	"buttomdisable": `buttomdisable-CA8AY`,
	"buttomselected": `buttomselected-j3Qiv`
};
export default ___CSS_LOADER_EXPORT___;
